import {
    useTheme, Box, Divider, Grid, TextField, Typography, Autocomplete, FormControlLabel, Button, Checkbox, Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import  { useState, useEffect } from "react";
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";


const QualityCheckRejectProcess = ({ rejectReelType, rejectReason, setRejectReason, selectedReason, setSelectedReason, rejectProductType, setRejectProductType, rejectStatus, setRejectStatus, rejectReasonID, setRejectReasonID, rejectRemarks, setRejectRemarks, enableReject, setEnableReject, open, onClose, buttonname, message,callReject }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [isMachineDataLoaded, setIsMachineDataLoaded] = useState(false);
    const [viewRemarks, setViewRemarks] = useState(false);

    useEffect(() => {
        if (!isMachineDataLoaded) {

            const para = {
                p_companyid: 1,
                p_plantid: 1,
            }
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REJECTION_REASON, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setRejectReason(data);
                        setSelectedReason(data[0]);
                        setRejectReasonID(data[0].id);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isMachineDataLoaded]);


    const handleRejectReasonChange = (event, value) => {
        setSelectedReason(value);
        setRejectReasonID(value.id);
    }






    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >
            {!viewRemarks && (
                <DialogTitle style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                    <Box display="flex" alignItems="center">
                        <WarningRoundedIcon style={{ marginRight: 8, color: 'pink', fontSize: "32" }} /> {/* Add icon with some margin */}
                        <Typography>{message}</Typography>
                    </Box>
                </DialogTitle>
            ) || (
                    <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                        <Box display="flex" alignItems="center">
                            <Typography variant="h4">{rejectReelType}</Typography>

                        </Box>

                    </DialogTitle>
                )}
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                {viewRemarks && (
                    <Box>
                        <Box
                            display="grid"
                            gridTemplateColumns={{
                                xs: 'repeat(2, 1fr)',
                                sm: 'repeat(2, 1fr)',
                                md: 'repeat(3, 1fr)',
                                lg: 'repeat(12, 1fr)',
                                xl: 'repeat(12, 1fr)',
                            }}
                            gridAutoRows="10px"
                            marginTop={5}
                            marginBottom={5}
                            gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '10px' }}
                        >

                            <Box
                                gridColumn={{
                                    xs: 'span 12',
                                    sm: 'span 12',
                                    md: 'span 12',
                                    lg: 'span 4',
                                    xl: 'span 4',
                                }}
                                display="flex"
                                alignItems="start"
                                justifyContent="start"
                            >
                                <Typography variant="h6">Reject Reason</Typography>
                            </Box>

                            <Box
                                gridColumn={{
                                    xs: 'span 12',
                                    sm: 'span 12',
                                    md: 'span 12',
                                    lg: 'span 8',
                                    xl: 'span 8',
                                }}
                                display="flex"
                                alignItems="start"
                                justifyContent="start"

                            >

                                <Autocomplete
                                    fullWidth
                                    value={selectedReason} // Use '' if sheeterSelectedChildRoll is empty or undefined
                                    onChange={handleRejectReasonChange}
                                    size="small"

                                    options={rejectReason || []}
                                    getOptionLabel={(option) => option?.reject_reason ?? ''}
                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                                />

                            </Box>




                        </Box>

                        <Box
                            display="grid"
                            gridTemplateColumns={{
                                xs: 'repeat(2, 1fr)',
                                sm: 'repeat(2, 1fr)',
                                md: 'repeat(3, 1fr)',
                                lg: 'repeat(12, 1fr)',
                                xl: 'repeat(12, 1fr)',
                            }}
                            gridAutoRows="10px"
                            marginBottom={5}
                            gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '10px' }}
                        >

                            <Box
                                gridColumn={{
                                    xs: 'span 2',
                                    sm: 'span 11',
                                    md: 'span 11',
                                    lg: 'span 4',
                                    xl: 'span 4',
                                }}
                                display="flex"
                                alignItems="start"
                                justifyContent="start"
                            >
                                <Typography variant="h6">Remarks</Typography>
                            </Box>

                            <Box
                                gridColumn={{
                                    xs: 'span 2',
                                    sm: 'span 11',
                                    md: 'span 11',
                                    lg: 'span 8',
                                    xl: 'span 8',
                                }}
                                display="flex"
                                alignItems="start"
                                justifyContent="start"

                            >

                                <TextField
                                    sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }}
                                    value={rejectRemarks}
                                    multiline
                                    fullWidth
                                    onChange={(e) => setRejectRemarks(e.target.value)}
                                    maxRows={4} type="text" size="small"></TextField>


                            </Box>

                        </Box>



                    </Box>
                )}
            </DialogContent>

            <DialogActions style={{ backgroundColor: colors.primary[400] }}>
                {!viewRemarks && (
                    <Button size='small' variant="contained" color="secondary" style={{ textTransform: 'none' }} onClick={() => { setViewRemarks(true); }} >
                        {buttonname}
                    </Button>
                ) || (
                        <Button size='small' variant="contained" color="secondary" style={{ textTransform: 'none' }} onClick={() => { callReject();setViewRemarks(true); }} >
                            Reject
                        </Button>
                    )}
                <Button size='small' variant="contained" color="secondary" onClick={() => { onClose(); setViewRemarks(false); }} style={{ textTransform: 'none' }} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>




    )
}
export default QualityCheckRejectProcess;